import { Utils } from "@/plugins/utils";

export default {
    namespaced: true,
    state: {
        att: null,
        insert: false,
        update: false,
        loading: false
    },
    getters: {
        
    },
    mutations: {
        set(state, att){
            state.att = att
            if (att)
                state.update = true
        },
        initForm(state){
            state.insert = false
            state.update = false
        }
    },
    actions: {
        async find(store){
            store.state.loading = true
            store.commit("initForm")
            await this._vm.$axios.get("/Oryx/AtualizationConfig/Find")
           .then(response => {
                let att = Utils.ValidateAxiosResponse(response.data);

                if (att && att.attdiasem) {
                    att.attdiasem = att.attdiasem
                        .split(',')
                        .map(Number)
                } else if (att) {
                    att.attdiasem = []
                }

                if (att && att.atthorario) {
                    att.atthorario = att.atthorario.substring(0, 5)
                }

                store.commit("set", att)
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
            });
            store.state.loading = false
            return true
        },
        save(store){
            if (store.state.att.attid){
                store.dispatch("update")
                return
            }
            store.dispatch("insert")
        },
        async insert(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
            await this._vm.$axios.post("/Oryx/AtualizationConfig/Insert", store.state.att )
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                store.dispatch("find")
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
        async update(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
            await this._vm.$axios.put("/Oryx/AtualizationConfig/Update", store.state.att )
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                store.dispatch("find")
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
        async delete(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
            await this._vm.$axios.delete("/Oryx/AtualizationConfig/Delete")
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                store.dispatch("find")
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
    }
}